import React, { useCallback, useEffect, useMemo, useState } from "react";
import Question from "./Question";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { WAY_ACTIVITIES_USER_DATA } from "../../../action/wayActivities";
import { AddSvg, MinusSvg } from "./WayActivity4";



// defaultQuestionsFormat(count){
    
//         purchaser: {
//             "firstName": "",
//             "lastName": "",
//             "phoneNumber": "",
//             "emailAddress":""
//         },
//         participants: [...Array(count)].map((_,i)=>{
//             return {
//                 "firstName": "",
//                 "lastName": ""
//             }
//         })


const WayActivity5 = (props) => {
    const { goNextPage, goPreviousPage, currency, handleSelectedDataChange, selectedData, selectedParticipantCount , eventDetailedInfo , getPriceTierName, t} = props;

    const [defaultQuestions, setDefaultQuestions] = useState(selectedData.defaultQuestions )
    const [purchaserAnswers, setPurchaserAnswers] = useState([]);
    const [participantAnswers, setParticipantAnswers] = useState( Array.from({ length: selectedParticipantCount }, () => []));

    const purchaserQuestions = eventDetailedInfo.customQuestions.filter(ques=>ques.config.scope == "purchaser");
    const participantQuestions = eventDetailedInfo.customQuestions.filter(ques=>ques.config.scope == "participant");

    // const existingBookingEmailId = useMemo(()=>{
    //   return localStorage.getItem(WAY_ACTIVITIES_USER_DATA) &&  JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)) && JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)).email;
    // },[]) 
    

    const handleAnswerChange = (answerObj, scope, participantIndex = null) => {
      if (scope === "purchaser") {
        setPurchaserAnswers((prev) => {
          const existingIndex = prev.findIndex((a) => a.questionId === answerObj.questionId);
          if (existingIndex >= 0) {
            const updated = [...prev];
            updated[existingIndex] = answerObj;
            return updated;
          }
          return [...prev, answerObj];
        });
      } else if (scope === "participant" && participantIndex !== null) {
        setParticipantAnswers((prev) => {
          const updated = [...prev];
          const answers = [...updated[participantIndex]];
          const existingIndex = answers.findIndex((a) => a.questionId === answerObj.questionId);
          if (existingIndex >= 0) {
            answers[existingIndex] = answerObj;
          } else {
            answers.push(answerObj);
          }
          updated[participantIndex] = answers;
          return updated;
        });
      }
    };


    // participantNumber starting from 0
    const handleDefaultQuestionsUpdate = ({isParticipant, participantNumber, key, value})=>{
        let defaultQuestions_ = JSON.parse(JSON.stringify(defaultQuestions));
        console.log(isParticipant, participantNumber, key, value);
        if(isParticipant){
           defaultQuestions_.participants[participantNumber][key]= value;
        } else{
            defaultQuestions_.purchaser[key]= value;
        }
        console.log(defaultQuestions_);

        setDefaultQuestions(defaultQuestions_);
    }

    const onAddOnQuantityUpdate = (id, change)=>{
      const currentAddOns = JSON.parse(JSON.stringify(selectedData.addOns));
      let updatedAddons = currentAddOns.map(addOn=>{
        if(addOn.id !=id) return addOn;
        return {
          ...addOn,
          quantity: addOn.quantity + change
        }
        
      })
    
      handleSelectedDataChange({addOns: updatedAddons});

    }

    const handleGoBack =()=>{
        handleSelectedDataChange({
            participantAnswers,
            purchaserAnswers,
            defaultQuestions
        })
        goPreviousPage();
    }

    const handleProceed = ()=>{
        handleSelectedDataChange({
            participantAnswers,
            purchaserAnswers,
            defaultQuestions
        })
        goNextPage();
    }





    useEffect(()=>{console.log(defaultQuestions)},[defaultQuestions]);

    return (<>
                <header className="inner-pages w-footer subpages">
                        <a className="button-back" onClick={handleGoBack}></a>
                        <div className="heading align-center">
                        <div class="header">
                            <p className="text">{t("way_activity.common.header_text")}</p>
                            {/* <img src={`${CMSPath}${props.logo}`} alt="" /> */}
                        </div>
                        </div>
                </header>
    
                <section id="activitiespage5" className="widgets container-bg activity-listing activity-questions-listing">
                    <div className="cutom-resp-container">
                         <section>
                            <div class="widget-header-title"> {t("way_activity.questions_page.header_title")}</div>
                            <div class="widget-header-subtitle"  >{t("way_activity.questions_page.header_subtitle")}</div>

                        </ section>



                  {/* for addons */}
                  { selectedData.addOns && selectedData.addOns.length >0 && 
                  <>      
                  {
                    <div className="pricetears-container pricetiers-container addons-container">
                    <div>
                      <div className="text-bold" >{t("way_activity.questions_page.add_ons_title")}</div>
                    </div>
                      {
                        selectedData.addOns.map((addon, index) => (
                                          
                                        
                          <div className="row" key={addon.id}>
                            <div className="info">
                              <p className="name">{addon.label}</p>
                              <p className="price">{`${currency} ${addon.price}`}</p>
                            </div>
                            <div className="quantity-controls">
                            
                              <button disabled={ addon.quantity<=0 } className={`qty-btn minus ${ (addon.quantity<=0 ) ? "disabled":""}`} onClick={() => onAddOnQuantityUpdate(addon.id, -1)} >
                              
                                      <MinusSvg />
                              
                              </button>
                              <p className="qty-value">{addon.quantity}</p>
                              <button disabled={ addon.quantity >= addon.maxQuantity } className={`qty-btn plus ${(addon.quantity >= addon.maxQuantity  ) ? "disabled":""}`}  onClick={() => onAddOnQuantityUpdate(addon.id, 1)} >
                              
                                    <AddSvg />
                                
                              </button>
                            </div>
                          </div>

                      ))
                      }
                    </div>
                  }
                   </>
                  }




                        <div className="purchaser-form">

                        {/* <div class="question" >
                            <div > First Name</div>
                            <input type="text" onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:false, key:"firstName", value: e.target.value})}} value={defaultQuestions.purchaser.firstName}/>
                            </div>

                            <div class="question">
                           
                            <div > Last Name</div>
                            <input type="text" onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:false, key:"lastName", value: e.target.value})}} value={defaultQuestions.purchaser.lastName}/>
                            </div>

                            <div class="question">
                            <div > Phone Number</div>
                            <input type="tel" onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:false, key:"phoneNumber", value: e.target.value})}} value={defaultQuestions.purchaser.phoneNumber}/>
                            </div>

                            <div class="question">
                            <div > Email</div>
                            <input type="email" disabled={existingBookingEmailId} onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:false, key:"emailAddress", value: e.target.value})}} value={defaultQuestions.purchaser.emailAddress}/>
                            </div> */}

                            {
                                purchaserQuestions.map(q=>
                                <div class="question" >
                                    { !(q.config && q.config.disabled) && <Question 
                                        key={q.id} 
                                        question={q}
                                        onAnswerChange={(a) => handleAnswerChange(a, "purchaser")} />}
                                </div>
                                )

                            }
                        </div>

                        {
                            selectedParticipantCount > 0 &&
                            <>
                            <div className="guest-question-container">
                                <div className="heading" >{t("way_activity.questions_page.guest_section_heading")}</div>
                                {
                                    [...Array(selectedParticipantCount)].map((_,index)=>{ return <>
                                        <div className="heading-guest-heading">{t("way_activity.questions_page.guest_label", { index: index + 1, priceTier: getPriceTierName()[index] })}</div>
   
                                        <div class="question">
                                          <div>
                                            <div > {t("way_activity.questions_page.first_name_label")}</div>
                                            <input type="text" onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:true, participantNumber:index,  key:"firstName", value: e.target.value})}} value={defaultQuestions.participants[index].firstName}/>
                                          </div>
                                        </div>

                                        <div class="question" >
                                          <div>
                                          <div > {t("way_activity.questions_page.last_name_label")}</div>
                                          <input type="text" onChange={(e)=>{handleDefaultQuestionsUpdate({isParticipant:true, participantNumber:index,  key:"lastName", value: e.target.value})}} value={defaultQuestions.participants[index].lastName}/>
                                          </div>
                                        </div>

                                        {
                                            participantQuestions.map(q=>
                                                 <div class="question" >
                                                        <Question 
                                                            key={q.id} 
                                                            question={q}
                                                            onAnswerChange={(a) => handleAnswerChange(a, "participant", index)}
                                                            />
                                                </div>
                                            )
                    
                                        }
                                        
                                        </>
                                    })

                                }
                                </div>
                            </>
                        }

                    </div>

                    <div class="row">
                        <div class="form-controls">
                          <button  
                          className="continue"
                          onClick={handleProceed}>
                              {t("way_activity.common.continue_button")}
                          </button>
                        </div>
                     </div>

                </section>
            </>
    );
};

const mapStateToProps = (state) => {
    return {
      installedAppVersion: state.store.installedAppVersion,
      installedAppBuildNo: state.store.installedAppBuildNo,
      currentHomePage: state.store2.currentHomePage,
      currentWidgetObj: state.store.sideNavBar.currentWidget,
      guestDetail: state.store.home.guestDetails,
      guestIsLoggedIn: state.store2.guestIsLoggedIn,
      currentWidgets: state.store.sideNavBar.currentWidget,
      dateFormat: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
        : "",
      // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
      serverTimeDate: state.store.home.serverTimeDate.date,
      serverDate: state.store.home.serverTimeDate,
    };
  };
  
  export default connect(mapStateToProps,
    {  })(
      withTranslation("translations")(WayActivity5)
    );




